<ul
  class="nav"
  *ngIf="authService.isAuthenticated()">
  <li class="nav-item">
    <a
      class="nav-link"
      routerLink="/admin/posts"
      routerLinkActive="active text-dark"
      >Posts</a
    >
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      routerLink="/admin/post-create"
      routerLinkActive="active text-dark"
      >Create Post</a
    >
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      routerLink="/account/logout"
      routerLinkActive="active text-dark"
      >Logout</a
    >
  </li>
</ul>

<router-outlet></router-outlet>
